import { createNumberConverter } from '../convert';
export function initTime() {
  createNumberConverter({
    format: 'H',
    paddingFormat: 'HH',
    maxLength: 2,
    getter: function getter(date) {
      return date.getHours();
    },
    field: 'hour'
  });
  createNumberConverter({
    format: 'h',
    paddingFormat: 'hh',
    maxLength: 2,
    getter: function getter(date) {
      return date.getHours();
    },
    field: 'hour'
  });
  createNumberConverter({
    format: 'm',
    paddingFormat: 'mm',
    maxLength: 2,
    getter: function getter(date) {
      return date.getMinutes();
    },
    field: 'minute'
  });
  createNumberConverter({
    format: 's',
    paddingFormat: 'ss',
    maxLength: 2,
    getter: function getter(date) {
      return date.getSeconds();
    },
    field: 'second'
  });
}